// utils/useAccessControl.js
export function getFeatureAccess(tier = "basic") {
    const access = {
      basic: {
        support: true,
        billing: true,
        notifications: false,
        tripHistory: false,
        csvUpload: false,
        createUser: false
      },
      standard: {
        support: true,
        billing: true,
        notifications: true,
        tripHistory: { allowed: true, days: 30 },
        csvUpload: false,
        createUser: false
      },
      premium: {
        support: true,
        billing: true,
        notifications: true,
        tripHistory: { allowed: true, days: 90 },
        csvUpload: false,
        createUser: false
      },
      admin: {
        support: true,
        billing: true,
        notifications: true,
        tripHistory: { allowed: true, days: 365 },
        csvUpload: true,
        createUser: true
      }
    };
  
    return access[tier] || access.basic;
  }
  